<script setup>
import GlucoseCalc from './pages/GlucoseCalc.vue'
</script>

<template>
  <GlucoseCalc />
</template>
